import { defineFcm } from '../shared/factory';

export const FCM_DOUBLE_OPTIN_ENABLED_NEW_USER = defineFcm('double_optin_enabled_new_user')
	.asBoolean()
	.withDefault(false)
	.toConfig();
